export default __webpack_public_path__ + "static/media/tutorial-pre-cadastro-pagina2.b5df3f4a.svg";